import Cookie from 'js-cookie'
import { decodeJwt } from 'jose'

import { cookies, urls } from '@/utils/constants'

/** Know if user is logged. */
export const isLogged = (): boolean => {
    const accessToken = Cookie.get(cookies.tokens.ACCESS_TOKEN)
    const refreshToken = Cookie.get(cookies.tokens.REFRESH_TOKEN)
    const token = refreshToken || accessToken

    const now = new Date(Date.now())

    now.setMinutes(now.getMinutes() + 2)

    const dateNow = Math.ceil(now.getTime() / 1_000)

    try {
        const decodedToken = decodeJwt(token)

        if (!decodedToken.exp) {
            return false
        }

        return decodedToken.exp > dateNow
    } catch {
        return false
    }
}

/** Know if the page is an authentication page. */
export const isAuthPage = (): boolean => {
    const path = new URL(window.location.href).pathname

    const authPages = [
        urls.auth.ACTIVATION,
        urls.auth.LOGIN,
        urls.auth.REGISTER,
        urls.auth.RESET_PASSWORD,
    ]

    return authPages.some((page) => path.includes(page))
}

/** Know if the page is an order page. */
export const isOrderPage = (): boolean => {
    const path = new URL(window.location.href).pathname

    const orderPages = [
        urls.CART,
        urls.orders.DETAILS,
        urls.orders.LIST,
        urls.catalogue.products.DETAILS,
        urls.catalogue.products.LIST,
    ]

    return orderPages.some((page) => path.includes(page))
}
